<template>
    <div v-if="form">
        <ValidationObserver ref="form" tag="form" @submit.prevent="handleSubmit" >
            <FormSlot name="name" :label="$t('credentials.form_name')" :rules="{required: true}" v-slot="{errors}">
                <input v-model="form.name" type="text" class="form-control" :placeholder="$t('credentials.form_name')" />
            </FormSlot>

            <div class="form-group">
                <label>{{ $t('credentials.form_active') }}</label>
                <div>
                    <button class="btn"
                            :class="[form.active ? 'btn-success' : 'btn-danger']"
                            @click.prevent="form.active = !form.active"
                    >
                        <span v-if="form.active">
                            {{$t('credentials.form_is_active')}} <fa-icon class="ml-2" icon="toggle-on" />
                        </span>
                        <span v-else>
                            {{$t('credentials.form_is_inactive')}} <fa-icon class="ml-2" icon="toggle-off" />
                        </span>
                    </button>
                </div>
            </div>

            <FormSlot v-for="field in accessProperties"
                      :key="field.name"
                      :rules="{required: field.required}"
                      :name="field.name"
                      :label="field.label"
                      v-slot="{errors}"
            >
                <input :type="field.type"
                       class="form-control"
                       v-model="form.data[field.name]"
                       autocomplete="off"
                >
                <span v-if="field.description" class="form-text text-muted">
                    {{ field.description }}
                </span>
            </FormSlot>

            <button class="btn btn-primary" :disabled="processing">
                <fa-icon icon="spinner" class="mr-2" spin v-if="processing" />

                <span v-if="!form.uuid">{{$t('_create')}}</span>
                <span v-else>{{$t('_save')}}</span>
            </button>
        </ValidationObserver>
    </div>
</template>

<script>

    import {FormSlot} from '@dealer-group/dealerui';
    import store from "../store/store";
    import {SAVE_CREDENTIAL} from "../store/types";

    export default {
        name: "Form",
        components: {FormSlot},
        computed: {
            ...store.mapState(['processing']),
            ...store.mapGetters(['credentialType']),
            ...store.mapFields(['credential']),

            accessProperties() {
                if (!this.credentialType) {
                    return [];
                }

                return this.credentialType.accessProperties;
            }
        },

        watch: {
            credential: {
                handler() {this.reset()},
                immediate: true
            },
        },

        data: () => ({form: null}),

        methods: {
            reset() {
                if (!this.credentialType || !this.credential) {
                    this.form = null;

                    return;
                }

                let form = {
                    uuid: null,
                    name: null,
                    active: true,
                    data: {},
                    type: this.credentialType.type,
                    ...this.credential || {}
                };

                this.accessProperties.forEach(o => {
                    form.data[o.name] = form.data[o.name] || null;
                });

                this.form = form;
            },

            async handleSubmit() {
                const isValid = await this.$refs.form.validate();

                if (! isValid) {
                    return;
                }

                store
                    .dispatch(SAVE_CREDENTIAL, this.form)
                    .then(() => {
                        this.$flash.success();
                    })
                    .catch(() => {
                        this.$flash.error('Wystąpił błąd walidacji');
                    });
            }
        }
    }
</script>

<style scoped>
    .btn {
        transition: all 0.4s;
    }
</style>
